import React, { useState, useRef, useEffect } from 'react'
import Modal from '@material-ui/core/Modal'
import bgVideo from '../../video/desktopVideo.mp4'
import smVideo from '../../video/mobileVideo.mp4'
import { CloseVideoIcon, TurnVolumeOn, TurnVolumeOff } from '../../assetss/img/index'
import './index.scss'

const VideoModal = ({ isAuth }) => {
  const [videoState, setVideoState] = useState(true)
  const [videoSrc, setVideoSrc] = useState()
  const [audioState, setAudioState] = useState(true)
  const videoRef = useRef()

  const openModal = JSON.parse(sessionStorage.getItem('playVideo'))

  const restartVideo = () => {
    setVideoState(false)
    sessionStorage.setItem('playVideo', true)
  }

  const toggleVolume = () => {
    videoRef.current.muted = !videoRef.current.muted
    setAudioState(videoRef.current.muted)
  }

  const onClose = () => setVideoState(prev => !prev)

  const chooseVideo = () => {
    if (window.screen.width <= 769) {
      return setVideoSrc(smVideo)
    } else return setVideoSrc(bgVideo)
  }

  useEffect(() => {
    if (videoRef && videoRef.current) {
      chooseVideo()
      videoRef?.current?.addEventListener('ended', () => sessionStorage.setItem('playVideo', true), false)
    }
  }, videoRef?.current)

  if (isAuth) {
    return null
  }

  if (openModal) {
    return null
  }

  return (
    <Modal open={videoState} onClose={onClose}>
      <div className='containerModal'>
        <div className='wrapper'>
          <div className='closeVideo' onClick={restartVideo}>
            <div className='label'>Close</div> <CloseVideoIcon />
          </div>

          <video className='vid' ref={videoRef} playsInline loop autoPlay muted>
            <source src={videoSrc} type='video/mp4' />
          </video>

          <div className='volume' onClick={toggleVolume}>
            <div className='label'>Volume </div>{audioState ? <TurnVolumeOff /> : <TurnVolumeOn />}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default VideoModal
